// Base content structure for image-based social login items
const baseSocialLoginContent = {
  type: "image",
  inputType: "",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "socialLogin",
    file: {},
    isUpdated: false,
  },
  translation: {
    input: "",
    flag: false,
    isUpdated: false,
  },
};

// Helper function to create a social login entry
const createSocialLoginEntry = (title: string, key: string) => ({
  title,
  content: {
    ...baseSocialLoginContent,
    data: {
      ...baseSocialLoginContent.data,
      key,
    },
  },
  isRequired: false,
  readonly: false,
  isButton: true,
});

// Social login entries
const socialLoginEntries = [
  { title: "Facebook", key: "facebookIcon" },
  { title: "Instagram", key: "instaIcon" },
  { title: "Twitter", key: "twitterIcon" },
  { title: "Vkontakte", key: "vkIcon" },
  { title: "LinkedIn", key: "linkedInIcon" },
  { title: "Twitch", key: "twitchIcon" },
  { title: "Amazon", key: "amazonIcon" },
  { title: "Mail", key: "mailIcon" },
];

// Generate social logins array
const socialLogins = socialLoginEntries.map(({ title, key }) =>
  createSocialLoginEntry(title, key)
);

export { socialLogins };
